import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tasks", "editButton", "viewMode", "editMode", "editor"]
  static values = { 
    inloopId: String,
    checklistType: String,
    editable: Boolean
  }

  connect() {
    console.log("Checklist editor connected for:", this.checklistTypeValue)
  }

  toggleEditMode() {
    // Update the textarea content to reflect current checkbox states
    this.updateEditorContent()
    
    this.viewModeTarget.classList.add('hidden')
    this.editModeTarget.classList.remove('hidden')
    this.editButtonTarget.classList.add('hidden')
  }

  updateEditorContent() {
    // Get all task elements
    const taskElements = this.tasksTarget.querySelectorAll('[data-task-id]')
    let markdownContent = []
    
    taskElements.forEach(taskElement => {
      const checkbox = taskElement.querySelector('input[type="checkbox"]')
      const textElement = taskElement.querySelector('span, label')
      
      if (checkbox && textElement) {
        // Get the task text without the (Mandatory) label if present
        let taskText = textElement.textContent.trim()
        const mandatoryMatch = taskText.match(/^(.*?)\s*\(Mandatory\)\s*$/)
        const isMandatory = mandatoryMatch !== null
        if (isMandatory) {
          taskText = mandatoryMatch[1].trim()
        }
        
        // Format as markdown checkbox
        const checkmark = checkbox.checked ? 'x' : ' '
        const mandatoryTag = isMandatory ? ' (Mandatory)' : ''
        markdownContent.push(`- [${checkmark}] ${taskText}${mandatoryTag}`)
      }
    })
    
    // Update the textarea with the current state
    this.editorTarget.value = markdownContent.join('\n')
  }

  cancelEdit() {
    this.viewModeTarget.classList.remove('hidden')
    this.editModeTarget.classList.add('hidden')
    this.editButtonTarget.classList.remove('hidden')
  }

  async saveChecklist() {
    const content = this.editorTarget.value

    try {
      const response = await fetch(`/inloops/${this.inloopIdValue}/checklists/${this.checklistTypeValue}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.getCSRFToken(),
          'Accept': 'application/json'
        },
        body: JSON.stringify({ content: content })
      })

      if (response.ok) {
        // Reload the page to show updated checklist
        window.location.reload()
      } else {
        console.error('Failed to save checklist')
      }
    } catch (error) {
      console.error('Error saving checklist:', error)
    }
  }

  async toggleTask(event) {
    if (!this.editableValue) {
      event.preventDefault()
      return
    }

    const checkbox = event.target
    const taskId = checkbox.dataset.taskId
    const completed = checkbox.checked
    
    // Update visual state immediately
    const taskElement = checkbox.closest('[data-task-id]')
    // Look for either span or label element that contains the task text
    const label = taskElement.querySelector('span, label')
    if (label) {
      if (completed) {
        label.classList.add('line-through')
      } else {
        label.classList.remove('line-through')
      }
    }

    try {
      const response = await fetch(`/inloops/${this.inloopIdValue}/checklists/${this.checklistTypeValue}/tasks/${taskId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.getCSRFToken(),
          'Accept': 'application/json'
        },
        body: JSON.stringify({ completed: completed })
      })

      if (!response.ok) {
        // Revert checkbox state if request failed
        checkbox.checked = !completed
        if (label) {
          if (completed) {
            label.classList.remove('line-through')
          } else {
            label.classList.add('line-through')
          }
        }
        console.error('Failed to update task')
      }
    } catch (error) {
      // Revert checkbox state on error
      checkbox.checked = !completed
      if (label) {
        if (completed) {
          label.classList.remove('line-through')
        } else {
          label.classList.add('line-through')
        }
      }
      console.error('Error updating task:', error)
    }
  }

  getCSRFToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ''
  }
}